import {Injectable} from '@angular/core';
import {BASE_URL} from '../constants';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {DocTypeToken} from './file.service';

@Injectable({
  providedIn: 'root'
})
export class FileShareService {
  URL = BASE_URL + '/share/';

  constructor(private http: HttpClient) { }

  public create(docIds: DocTypeToken[], formData: any): Observable<any>{
    let params = formData;
    if (params['password'] === '') {
      delete params['password'];
    }
    docIds.forEach(doc => {
      params[doc.type] = doc.tokens;
    });

    params['name'] = 'test';
    return this.http.post(this.URL + 'create/', params);
  }

  public check(shareToken: string): Observable<any> {
    return this.http.get(this.URL + 'check/' + shareToken + '/');
  }

  public get(status: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('status', status);
    return this.http.get(this.URL + 'get/', {params});
  }

  public downloadInfo(token, password, queue_id): Observable<any> {
    let params = new HttpParams();
    if (password !== '') {
      params = params.append('password', password);
    }
    params = params.append('queue_id', queue_id);
    return this.http.post(this.URL + 'download_info/' + token + '/', params);
  }

  public download(token, password, fileToken, queue_id): Observable<any> {
    let params = new HttpParams();
    if (password !== '') {
      params = params.append('password', password);
    }
    params = params.append('queue_id', queue_id);
    params = params.append('file_token', fileToken);
    return this.http.post(this.URL + 'download/' + token + '/', params, {observe: 'events', responseType: 'blob', reportProgress: true});
  }

  public revoke_access(token: string): Observable<any> {
    return this.http.get(this.URL + 'revoke/' + token + '/');
  }
}
